// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  position: relative;
  height: 100%;
}

.drop-zone-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(25, 118, 210, 0.15);
  border: 3px dashed rgba(25, 118, 210, 0.6);
  border-radius: 8px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.drop-zone-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: rgba(25, 118, 210, 0.9);
}
.drop-zone-content mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
}
.drop-zone-content span {
  font-size: 18px;
  font-weight: 500;
}

.header {
  margin-top: 3px;
  margin-bottom: 20px;
}

table {
  width: 100%;
}

.table-container {
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

.compact {
  height: 38px !important;
}

.compact .mat-mdc-cell,
.compact .mat-mdc-header-cell {
  font-size: 10pt;
}

.compact .mdc-data-table__cell, .mdc-data-table__header-cell {
  padding: 0;
}

.compact mat-icon {
  font-size: 15pt;
  height: 20px;
  width: 20px;
  --mat-icon-button-icon-size: 20px;
  --mat-icon-button-state-layer-size: 32px;
}

.redButton {
  min-width: 100px;
  color: white;
  background-color: red;
}

.mat-mdc-raised-button {
  min-width: unset;
}

.spacer {
  flex: 1 1 auto;
}

#asset-container {
  position: relative;
  margin-top: 30px;
}

#lock-button {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 10;
}

.mat-mdc-row .mat-mdc-cell {
  cursor: pointer;
}

.mat-mdc-form-field {
  margin-right: 25px;
}

.file-upload {
  margin-right: 15px;
  cursor: pointer;
}

.progress {
  padding-top: 25px;
  padding-bottom: 25px;
  width: 95%;
}

.dismiss {
  padding-top: 10px;
}

.fix-align {
  margin-left: -4px;
  text-align: left;
}

th,
td {
  -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
             supported by Chrome, Edge, Opera and Firefox */
  -webkit-touch-callout: none; /* iOS Safari */
}

table .mat-mdc-icon-button:not(.add-dataset-btn) {
  height: unset !important;
  width: unset !important;
  line-height: unset !important;
  margin: unset !important;
}

ngx-monaco-editor {
  object-fit: fill;
  height: calc(100% - 110px) !important;
}

#split-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

as-split {
  flex: 1;
  min-height: 0;
}

as-split-area {
  display: flex;
  flex-direction: column;
}

app-terminal {
  height: calc(100% - 50px) !important;
  display: block;
}

.invisible-placeholder {
  height: 48px;
}

.cache-action-button {
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
.cache-action-button:hover {
  opacity: 1;
}

.add-dataset-btn {
  margin: -4px 0 0 3px;
}

mat-chip-set {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
  margin-left: 10px;
  height: 40px;
}

.dataset-menu-content {
  padding: 8px 16px;
  min-width: 250px;
}

.dataset-input {
  width: 100%;
}

.create-new-option {
  font-style: italic;
}
.create-new-option mat-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
  margin-right: 8px;
}

.dataset-spinner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  height: 26px;
  margin-left: 0.75rem;
}

.search-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: rgba(25, 118, 210, 0.9);
  margin-right: 16px;
}
.search-indicator mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.search-indicator button {
  margin-left: 4px;
}

.folder-row {
  cursor: pointer;
}
.folder-row:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.mat-column-icon {
  width: 40px !important;
  max-width: 40px !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.folder-icon,
.file-icon {
  color: rgba(0, 0, 0, 0.35);
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/data/raw/raw.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;AACF;AACE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,eAAA;EACA,mBAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,gBAAA;EACA,OAAA;EACA,aAAA;AADF;;AAIA;EACE,uBAAA;AADF;;AAIA;;EAEE,eAAA;AADF;;AAIA;EACE,UAAA;AADF;;AAIA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,iCAAA;EACA,wCAAA;AADF;;AAIA;EACE,gBAAA;EACA,YAAA;EACA,qBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,kBAAA;EACA,eAAA;AADF;;AAIA;EACE,iBAAA;EACA,oBAAA;EACA,UAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,iBAAA;EACA,gBAAA;AADF;;AAIA;;EAEE,yBAAA,EAAA,WAAA,EACA,mBAAA,EACA,4BAAA,EACA,2BAAA;EACA,iBAAA,EAAA;2DAAA;EAEA,2BAAA,EAAA,eAAA;AADF;;AAIA;EACE,wBAAA;EACA,uBAAA;EACA,6BAAA;EACA,wBAAA;AADF;;AAIA;EACE,gBAAA;EACA,qCAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;AADF;;AAIA;EACE,OAAA;EACA,aAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,oCAAA;EACA,cAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,YAAA;EACA,8BAAA;AADF;AAGE;EACE,UAAA;AADJ;;AAMA;EACE,oBAAA;AAHF;;AAMA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AAHF;;AAMA;EACE,iBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,WAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;AAKE;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAHJ;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;AAJF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;AALF;AAOE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AALJ;AAQE;EACE,gBAAA;AANJ;;AAUA;EACE,eAAA;AAPF;AASE;EACE,qCAAA;AAPJ;;AAWA;EACE,sBAAA;EACA,0BAAA;EACA,4BAAA;EACA,6BAAA;AARF;;AAWA;;EAEE,0BAAA;EACA,eAAA;AARF","sourcesContent":[":host {\n  display: block;\n  position: relative;\n  height: 100%;\n}\n\n.drop-zone-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(25, 118, 210, 0.15);\n  border: 3px dashed rgba(25, 118, 210, 0.6);\n  border-radius: 8px;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.drop-zone-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  color: rgba(25, 118, 210, 0.9);\n\n  mat-icon {\n    font-size: 64px;\n    width: 64px;\n    height: 64px;\n  }\n\n  span {\n    font-size: 18px;\n    font-weight: 500;\n  }\n}\n\n.header {\n  margin-top: 3px;\n  margin-bottom: 20px;\n}\n\ntable {\n  width: 100%;\n}\n\n.table-container {\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.compact {\n  height: 38px !important;\n}\n\n.compact .mat-mdc-cell,\n.compact .mat-mdc-header-cell {\n  font-size: 10pt;\n}\n\n.compact .mdc-data-table__cell, .mdc-data-table__header-cell {\n  padding: 0;\n}\n\n.compact mat-icon {\n  font-size: 15pt;\n  height: 20px;\n  width: 20px;\n  --mat-icon-button-icon-size: 20px;\n  --mat-icon-button-state-layer-size: 32px;\n}\n\n.redButton {\n  min-width: 100px;\n  color: white;\n  background-color: red;\n}\n\n.mat-mdc-raised-button {\n  min-width: unset;\n}\n\n.spacer {\n  flex: 1 1 auto;\n}\n\n#asset-container {\n  position: relative;\n  margin-top: 30px;\n}\n\n#lock-button {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  z-index: 10;\n}\n\n.mat-mdc-row .mat-mdc-cell {\n  cursor: pointer;\n}\n\n.mat-mdc-form-field {\n  margin-right: 25px;\n}\n\n.file-upload {\n  margin-right: 15px;\n  cursor: pointer;\n}\n\n.progress {\n  padding-top: 25px;\n  padding-bottom: 25px;\n  width: 95%;\n}\n\n.dismiss {\n  padding-top: 10px;\n}\n\n.fix-align {\n  margin-left: -4px;\n  text-align: left;\n}\n\nth,\ntd {\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Old versions of Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none; /* Non-prefixed version, currently\n                                  supported by Chrome, Edge, Opera and Firefox */\n  -webkit-touch-callout: none; /* iOS Safari */\n}\n\ntable .mat-mdc-icon-button:not(.add-dataset-btn) {\n  height: unset !important;\n  width: unset !important;\n  line-height: unset !important;\n  margin: unset !important;\n}\n\nngx-monaco-editor {\n  object-fit: fill;\n  height: calc(100% - 110px) !important;\n}\n\n#split-container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\nas-split {\n  flex: 1;\n  min-height: 0;\n}\n\nas-split-area {\n  display: flex;\n  flex-direction: column;\n}\n\napp-terminal {\n  height: calc(100% - 50px) !important;\n  display: block;\n}\n\n.invisible-placeholder {\n  height: 48px;\n}\n\n.cache-action-button {\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n// Inline dataset chips\n.add-dataset-btn {\n  margin: -4px 0 0 3px;\n}\n\nmat-chip-set {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 0;\n  margin-left: 10px; // Prevent hover shadow clipping on first element\n  height: 40px;\n}\n\n.dataset-menu-content {\n  padding: 8px 16px;\n  min-width: 250px;\n}\n\n.dataset-input {\n  width: 100%;\n}\n\n.create-new-option {\n  font-style: italic;\n\n  mat-icon {\n    font-size: 18px;\n    height: 18px;\n    width: 18px;\n    margin-right: 8px;\n  }\n}\n\n.dataset-spinner {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  align-self: center;\n  height: 26px;\n  margin-left: 0.75rem;\n}\n\n// Folder navigation styles\n.search-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: rgba(25, 118, 210, 0.9);\n  margin-right: 16px;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  button {\n    margin-left: 4px;\n  }\n}\n\n.folder-row {\n  cursor: pointer;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.04);\n  }\n}\n\n.mat-column-icon {\n  width: 40px !important;\n  max-width: 40px !important;\n  padding-left: 8px !important;\n  padding-right: 8px !important;\n}\n\n.folder-icon,\n.file-icon {\n  color: rgba(0, 0, 0, 0.35);\n  font-size: 18px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
